const { getElement, getElements } = window.BAO.Utils
export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    if (!this.els?.zakeke?.exists) return

    this.handleZakeke = this.handleZakeke.bind(this)

    this.listeners.add(this.els.zakeke.element, 'click', this.handleZakeke)
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    const ringSizeIsValid = this.checkRingSizeValid()
    const personalisationIsValid = this.checkPersonalisationValid()
    const personalisationCheckboxIsTicker = this.checkTickboxValid()
    const stoneSelectionIsValid = this.checkStoneSelectionValid()

    if (
      !personalisationIsValid ||
      !personalisationCheckboxIsTicker ||
      !ringSizeIsValid ||
      !stoneSelectionIsValid
    ) {
      return
    }

    if (await this.handleOneOfAKindProduct()) return

    // Check if gift wrap is selected
    const giftWrapVariantId = this.checkGiftWrapValid()

    if (giftWrapVariantId) {
      const mainProductVariantId = Number(
        this.form.querySelector('input[name="id"]').value,
      )

      // Add the gift wrap product to cart with a reference to the main product's line item key
      await window.BAO.Cart.cartAdd({
        items: [
          {
            quantity: 1,
            id: giftWrapVariantId,
            properties: {
              _giftwrap_parent_product: mainProductVariantId,
            },
          },
        ],
      })
    }

    // Check if gift wrap is selected
    const freeRingSizerVariantId = this.checkFreeRingSizerValid()

    if (freeRingSizerVariantId) {
      const mainProductVariantId = Number(
        this.form.querySelector('input[name="id"]').value,
      )

      // Add the gift wrap product to cart with a reference to the main product's line item key
      await window.BAO.Cart.cartAdd({
        items: [
          {
            quantity: 1,
            id: freeRingSizerVariantId,
            properties: {
              _giftwrap_parent_product: mainProductVariantId,
              _hide_product: true,
            },
          },
        ],
      })
    }

    const isPersonalisation =
      e.submitter?.getAttribute('data-personalisation-form-el') ===
        'addToCart' ||
      e.submitter?.getAttribute('data-charms-form-el') === 'addToCart'

    await this.addToCart(isPersonalisation, e)
  }

  async handleNestedLineItems () {
    const diamondShape = this.form.querySelector(
      'input[name="properties[_diamond_shape]"]',
    )
    const diamondVariantId = this.form.querySelector(
      'input[name="properties[_diamond_variant_id]"]',
    )
    const diamondQuantity = this.form.querySelector(
      'input[name="properties[_diamond_quantity]"]',
    )
    const diamondUUID = this.form.querySelector(
      'input[name="properties[_diamond_uuid]"]',
    )
    const parentId = this.form.querySelector('input[name="id"]').value

    // Check that all the properties are enabled and have values
    const diamondPropertiesAreValid = [
      diamondShape,
      diamondVariantId,
      diamondQuantity,
      diamondUUID,
    ].every((el) => el && !el.disabled && el.value.trim() !== '')

    if (!diamondPropertiesAreValid) {
      // If any of the properties are not valid, we assume stones are not
      // enabled for this product or that the user has not selected a stone
      return
    }

    const parentPayload = {
      quantity: 1,
      id: parseInt(parentId, 10),
      properties: {
        Diamonds: `x${parseInt(diamondQuantity.value, 10)} ${diamondShape.value}`,
        _has_diamonds: parseInt(diamondQuantity.value, 10) > 0,
        _diamond_shape: diamondShape.value,
        _diamond_variant_id: parseInt(diamondVariantId.value, 10),
        _diamond_quantity: parseInt(diamondQuantity.value, 10),
        _diamond_uuid: diamondUUID.value,
      },
    }

    const formData = new FormData(this.form)
    for (const [name, value] of formData.entries()) {
      if (name.startsWith('properties[')) {
        const propName = name.slice(11, -1)
        if (!(propName in parentPayload.properties)) {
          parentPayload.properties[propName] = value
        }
      }
    }

    const diamondPayload = {
      quantity: parseInt(diamondQuantity.value, 10),
      id: parseInt(diamondVariantId.value, 10),
      parent_id: parentId,
      properties: {
        _is_diamond: true,
        _diamond_shape: diamondShape.value,
        _diamond_uuid: diamondUUID.value,
      },
    }

    await window.BAO.Cart.addItem([
      parentId && parentPayload,
      parseInt(diamondQuantity.value, 10) > 0 && diamondPayload,
    ])

    document.querySelector('product-diamonds')?.updateUUID()
  }

  async handleStones () {
    const stoneType = this.form.querySelector(
      'input[name="properties[_stone_type]"]',
    )
    const stoneSetting = this.form.querySelector(
      'input[name="properties[_stone_setting]"]',
    )
    const stoneVariantId = this.form.querySelector(
      'input[name="properties[_stone_variant_id]"]',
    )
    const stoneQuantity = this.form.querySelector(
      'input[name="properties[_stone_quantity]"]',
    )
    const stoneUUID = this.form.querySelector(
      'input[name="properties[_stone_uuid]"]',
    )

    // Check that all the properties are enabled and have values
    const propertiesAreValid = [
      stoneType,
      stoneVariantId,
      stoneQuantity,
      stoneUUID,
    ].every((el) => el && !el.disabled && el.value.trim() !== '')

    if (!propertiesAreValid) {
      // If any of the properties are not valid, we assume stones are not
      // enabled for this product or that the user has not selected a stone
      return
    }

    // Add the gift wrap product to cart with a reference to the main product's line item key
    await window.BAO.Cart.addItem([
      {
        quantity: parseInt(stoneQuantity.value, 10),
        id: parseInt(stoneVariantId.value, 10),
        properties: {
          _is_stone: true,
          _stone_setting: stoneSetting?.value,
          _stone_type: stoneType.value,
          _stone_quantity: stoneQuantity.value,
          _stone_uuid: stoneUUID.value,
        },
      },
    ])

    document.querySelector('product-stones')?.updateUUID()
  }

  async handleOneOfAKindProduct () {
    // Find one of a kind property input if it exists
    this.oneOfAKindInput = this.form?.querySelector(
      `input[name="properties[_one_of_a_kind]"]`,
    )
    this.isOneOfAKind = !!this.oneOfAKindInput

    // If not a one of a kind product, continue with normal flow
    if (!this.isOneOfAKind) return false

    const cartObj = await BAO.Cart.getCart()
    const variantId = this.form.querySelector('input[name="id"]').value
    const existingItem = cartObj.items.find(
      (item) =>
        item.variant_id === Number(variantId) &&
        item.properties?._one_of_a_kind === 'true',
    )

    if (existingItem) {
      // Product already exists in cart, don't add again but open cart drawer
      window.drawers.activeDrawerKey = 'cart'

      return true
    }

    return false
  }

  checkGiftWrapValid () {
    const giftWrapRadio = document.querySelector(
      '[data-gift-wrap-el="radio"]:checked[data-product-variant-id]:not([data-product-variant-id=""])',
    )
    if (!giftWrapRadio) return false

    return giftWrapRadio.dataset.productVariantId
  }

  checkFreeRingSizerValid () {
    const freeRingSizerRadio = document.querySelector(
      '[data-product-ring-builder-el="ring_sizer_input"]:checked[data-product-variant-id]:not([data-product-variant-id=""])',
    )
    if (!freeRingSizerRadio) return false

    return freeRingSizerRadio.dataset.productVariantId
  }

  checkTickboxValid () {
    const requiredCheckbox = this.form.querySelector('[product-form-required]')

    if (!requiredCheckbox) {
      return true
    } else {
      if (requiredCheckbox.checked) {
        requiredCheckbox.classList.toggle(
          'prd-Form_CheckboxInput-required',
          false,
        )

        return true
      } else {
        requiredCheckbox.classList.toggle(
          'prd-Form_CheckboxInput-required',
          true,
        )

        return false
      }
    }
  }

  checkPersonalisationValid () {
    const requiredFieldEls = getElements(
      `[product-form-personalisation-required][data-form-id="${this.dataset.formId}"]`,
    )

    if (
      requiredFieldEls.length === 0 ||
      !this.hasAttribute(['data-personalisation-form'])
    ) {
      return true
    } else {
      const personalisationTriggerEl = getElement(
        `[product-form-personalisation-trigger][data-form-id="${this.dataset.formId}"]`,
      )
      const invalidFields = requiredFieldEls.filter((requiredFieldEl) => {
        return requiredFieldEl.value === ''
      })

      if (personalisationTriggerEl) {
        personalisationTriggerEl.classList.toggle(
          'prd-Form_Variant-required',
          invalidFields.length > 0,
        )
      }

      return invalidFields.length === 0
    }
  }

  checkRingSizeValid () {
    const requiredFieldEls = getElements(
      `[product-form-ringsize-required][data-form-id="${this.dataset.formId}"]:not([disabled])`,
    )

    if (requiredFieldEls.length === 0) {
      return true
    } else {
      const ringSizeTriggerEl = getElements(
        `[product-form-ringsize-trigger][form="${this.dataset.formId}"]`,
      )
      const selected = ringSizeTriggerEl.filter((requiredFieldEl) => {
        return requiredFieldEl.checked === true
      })

      requiredFieldEls.forEach((el) => {
        el.classList.toggle('prd-Form_Variant-required', selected.length === 0)
      })

      return selected.length !== 0
    }
  }

  checkStoneSelectionValid () {
    const productStonesEl = document.querySelector('product-stones')

    if (!productStonesEl) {
      return true // No stone customization available
    }

    // Check if stone options are visible (not hidden)
    const stoneTypeFormOption =
      productStonesEl.els['stone-type-form-option']?.element
    const stoneSettingFormOption =
      productStonesEl.els['stone-setting-form-option']?.element
    const stoneQuantityFormOption =
      productStonesEl.els['stone-quantity-form-option']?.element

    // Get error elements
    const stoneTypeError = productStonesEl.els['stone-type-error']?.element
    const stoneSettingError =
      productStonesEl.els['stone-setting-error']?.element
    const stoneQuantityError =
      productStonesEl.els['stone-quantity-error']?.element

    const isStoneTypeVisible =
      stoneTypeFormOption &&
      stoneTypeFormOption.getAttribute('aria-hidden') !== 'true'
    const isStoneSettingVisible =
      stoneSettingFormOption &&
      stoneSettingFormOption.getAttribute('aria-hidden') !== 'true'
    const isStoneQuantityVisible =
      stoneQuantityFormOption &&
      stoneQuantityFormOption.getAttribute('aria-hidden') !== 'true'

    // Check if any stone options are already selected
    const stoneSettingSelected =
      stoneSettingFormOption &&
      stoneSettingFormOption.querySelector('[aria-selected="true"]')
    const stoneTypeSelected =
      stoneTypeFormOption &&
      stoneTypeFormOption.querySelector('[aria-selected="true"]')
    const stoneQuantitySelected =
      stoneQuantityFormOption &&
      stoneQuantityFormOption.querySelector('[aria-selected="true"]')

    // Check if engraving tab is currently active (user is on "Engrave this item" tab)
    const engravingTabActive =
      document.querySelector(
        '[data-personalisation-tabs-el="tab"][aria-controls="panel-add-personalisation"][aria-selected="true"]',
      ) !== null

    // Hide all error messages by default
    if (stoneTypeError) stoneTypeError.setAttribute('aria-hidden', 'true')
    if (stoneSettingError) {
      stoneSettingError.setAttribute('aria-hidden', 'true')
    }
    if (stoneQuantityError) {
      stoneQuantityError.setAttribute('aria-hidden', 'true')
    }

    // If engraving tab is active, skip stone validation entirely and allow form submission
    if (engravingTabActive) {
      return true
    }

    // If no stone options are visible, validation passes
    if (
      !isStoneTypeVisible &&
      !isStoneSettingVisible &&
      !isStoneQuantityVisible
    ) {
      return true
    }

    // If stone setting is visible but already selected, we only need to validate stone type and quantity if visible
    if (
      stoneSettingSelected &&
      !isStoneTypeVisible &&
      !isStoneQuantityVisible
    ) {
      return true
    }

    // Check if product-stones component has completed its selection
    const selectedDataComplete = productStonesEl.selectedDataComplete

    // Show error messages for incomplete selections
    if (!selectedDataComplete && isStoneTypeVisible && !stoneTypeSelected) {
      if (stoneTypeError) stoneTypeError.setAttribute('aria-hidden', 'false')
    }

    if (
      !selectedDataComplete &&
      isStoneSettingVisible &&
      !stoneSettingSelected
    ) {
      if (stoneSettingError) {
        stoneSettingError.setAttribute('aria-hidden', 'false')
      }
    }

    if (
      !selectedDataComplete &&
      isStoneQuantityVisible &&
      !stoneQuantitySelected
    ) {
      if (stoneQuantityError) {
        stoneQuantityError.setAttribute('aria-hidden', 'false')
      }
    }

    return selectedDataComplete
  }

  base64ToBlob (base64Data, mimeType = 'image/jpeg') {
    const base64 = base64Data.replace(/^data:image\/[a-z]+;base64,/, '')
    const byteCharacters = atob(base64)
    const byteNumbers = new Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    return new Blob([new Uint8Array(byteNumbers)], { type: mimeType })
  }

  async handleFileUpload (fileInput) {
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      return null
    }

    const file = fileInput.files[0]

    const base64Data = await this.fileToBase64(file)

    return await this.uploadBase64ToShopify(base64Data)
  }

  fileToBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  async uploadBase64ToShopify (base64Data) {
    if (!base64Data) return

    try {
      const blob = this.base64ToBlob(base64Data, 'image/jpeg')
      const url = `https://daniella-draper-new.by-association-only.workers.dev/api/images?shop=${window.theme.permanentDomain}`

      const response = await fetch(url, {
        method: 'POST',
        body: blob,
        headers: {
          'Content-Type': 'image/jpeg',
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      return await response.json()
    } catch (error) {
      console.error('Error uploading image to Shopify:', error)
      throw error
    }
  }

  setButtonState (formButton, isUploading) {
    const formPrice = formButton.querySelector('[data-product-price]')
    const formButtonText = formButton.querySelector(
      '[data-product-add-to-cart-text]',
    )
    const formUploadingText = formButton.querySelector(
      '[data-product-uploading]',
    )

    formPrice.ariaHidden = isUploading ? 'true' : 'false'
    formButtonText.ariaHidden = isUploading ? 'true' : 'false'
    formUploadingText.ariaHidden = isUploading ? 'false' : 'true'
    formButton.disabled = isUploading
    this.isAddingPersonalisation = isUploading
  }

  createHiddenInput (name, value) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    this.form.appendChild(input)

    return input
  }

  async addToCart (isPersonalisation, e) {
    if (isPersonalisation) {
      const formButton = e.submitter

      this.setButtonState(formButton, true)

      try {
        const base64DataElement = this.form.querySelector(
          '[name="_preview_image"]',
        )

        const fileInput = this.form.querySelector(
          '[name="attributes[_personalisation_upload]"]',
        )
        const fileName = fileInput?.value.split('\\').pop()

        const fileInputInput = this.form.querySelector(
          '[data-personalisation-file-upload-el="input"]',
        )
        const fileInputShouldUpload = fileInputInput?.disabled === false

        const personalisationPreviewUploadResult =
          await this.uploadBase64ToShopify(base64DataElement?.value)

        let userFileUploadResult = null

        if (fileInput?.files?.length > 0 && fileInputShouldUpload) {
          try {
            userFileUploadResult = await this.handleFileUpload(fileInput)
          } catch (error) {
            console.warn('Failed to upload file:', error)
          }
        }

        if (base64DataElement) {
          base64DataElement.value = ''
        }

        if (fileName) {
          this.createHiddenInput('properties[File_Name]', fileName)
        }

        if (fileInput && userFileUploadResult && userFileUploadResult.url) {
          this.createHiddenInput(
            'properties[custcol_dd_pfl]',
            userFileUploadResult.url,
          )
        }

        if (
          personalisationPreviewUploadResult &&
          personalisationPreviewUploadResult.url
        ) {
          this.createHiddenInput(
            'properties[personalisation_preview]',
            personalisationPreviewUploadResult.url,
          )
        }

        this.setButtonState(formButton, false)

        window.BAO.dispatchEvent(window.BAO.EVENTS.PDP.CLEAN_UP)

        await window.BAO.Cart.addItemFromForm(this.form)
          .then((response) => {
            // Create a custom event to notify that item was added successfully
            const addToCartEvent = new CustomEvent('productAddedToCart', {
              detail: {
                success: true,
                item: response,
                formId: this.dataset.formId,
              },
              bubbles: true,
            })

            // Dispatch the event on window
            window.dispatchEvent(addToCartEvent)

            return response
          })
          .catch((error) => {
            // Create a custom event for cart add failure
            const addToCartFailEvent = new CustomEvent(
              'productAddToCartFailed',
              {
                detail: {
                  success: false,
                  error,
                  formId: this.dataset.formId,
                },
                bubbles: true,
              },
            )

            window.dispatchEvent(addToCartFailEvent)
            throw error
          })
      } catch (error) {
        this.setButtonState(formButton, false)

        await window.BAO.Cart.addItemFromForm(this.form)
          .then((response) => {
            // Create a custom event to notify that item was added successfully
            const addToCartEvent = new CustomEvent('productAddedToCart', {
              detail: {
                success: true,
                item: response,
                formId: this.dataset.formId,
              },
              bubbles: true,
            })

            // Dispatch the event on window
            window.dispatchEvent(addToCartEvent)

            return response
          })
          .catch((error) => {
            // Create a custom event for cart add failure
            const addToCartFailEvent = new CustomEvent(
              'productAddToCartFailed',
              {
                detail: {
                  success: false,
                  error,
                  formId: this.dataset.formId,
                },
                bubbles: true,
              },
            )

            window.dispatchEvent(addToCartFailEvent)
            throw error
          })
      }

      // Always handle stones separately (if configured)
      await this.handleStones()
    } else {
      // Check if this product has diamonds configured
      const diamondQuantityInput = this.form.querySelector(
        'input[name="properties[_diamond_quantity]"]',
      )
      const hasDiamonds =
        diamondQuantityInput &&
        !diamondQuantityInput.disabled &&
        diamondQuantityInput.value.trim() !== '' &&
        parseInt(diamondQuantityInput.value, 10) > 0

      if (hasDiamonds) {
        // Use nested line items API (adds both parent + diamonds in one operation)
        await this.handleNestedLineItems()
      } else {
        // No diamonds - add main product normally
        await window.BAO.Cart.addItemFromForm(this.form)
          .then((response) => {
            // Create a custom event to notify that item was added successfully
            const addToCartEvent = new CustomEvent('productAddedToCart', {
              detail: {
                success: true,
                item: response,
                formId: this.dataset.formId,
              },
              bubbles: true,
            })

            // Dispatch the event on window
            window.dispatchEvent(addToCartEvent)

            return response
          })
          .catch((error) => {
            // Create a custom event for cart add failure
            const addToCartFailEvent = new CustomEvent(
              'productAddToCartFailed',
              {
                detail: {
                  success: false,
                  error,
                  formId: this.dataset.formId,
                },
                bubbles: true,
              },
            )

            window.dispatchEvent(addToCartFailEvent)
            throw error
          })
      }

      // Always handle stones separately (if configured)
      await this.handleStones()
    }
  }

  handleZakeke () {
    const personalisationCheckboxIsTicker = this.checkTickboxValid()

    if (!personalisationCheckboxIsTicker) return

    const zakekeUrl = `${window.zakekeUrl || '/apps/zakeke'}?pid=${
      this.form.querySelector('input[name="zakeke-product-id"]').value
    }`

    this.form.action = zakekeUrl

    this.form.submit()
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
